import React from 'react'
import Banner from '../components/Header/Banner'
import Products from '../components/products/Products'
import Services from '../components/Services/Services'
import PromoProducts from '../components/PromoProducts/PromoProducts'

const HomeScreen = () => {
    return (
        <main className="w-full">
            <Banner />
            <Services />
            <PromoProducts />
            <Products />
        </main>
    )
}

export default HomeScreen
